export default "__VITE_ASSET__Bsbvdbou__"